import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const MultiColoredStarIcon = ({ fill = '#4ee4b3', border = '#024cbc', ...props }) => {

  return (
    <Icon viewBox="0 0 22 21" {...props}>
      <g fill="none">
        <path
          fill={fill}
          d="M20.6,8.6 C21,8.2 21.1,7.7 21,7.2 C20.8,6.7 20.4,6.4 19.8,6.4 L14.4,5.9 C14.4,5.9 14.3,5.9 14.3,5.8 L12.1,0.8 C11.9,0.3 11.5,0 11,0 C10.5,0 10.1,0.3 9.8,0.8 L7.6,5.8 C7.6,5.8 7.5,5.8 7.5,5.9 L2.2,6.4 C1.6,6.5 1.2,6.8 1,7.2 C0.8,7.7 1,8.2 1.4,8.6 L5.5,12.7 C5.5,12.7 5.5,12.8 5.5,12.8 L3.9,18.4 C3.7,19.3 4.1,19.7 4.3,19.8 C4.5,19.9 5,20.2 5.8,19.7 L11,16.1 L16.2,19.7 C16.5,19.9 16.8,20 17,20 C17.3,20 17.6,19.9 17.7,19.8 C17.9,19.7 18.4,19.3 18.1,18.4 L16.5,12.8 C16.5,12.8 16.5,12.7 16.5,12.7 L20.6,8.6 Z"
        />
        <path
          fill={border}
          d="M11,14.2 C11.4,14.2 11.8,14.3 12.1,14.5 C12.1,14.5 12.1,14.5 12.1,14.5 L15.6,16.9 L14.6,13.4 C14.4,12.7 14.6,11.9 15.1,11.4 L18.1,8.3 L14.2,7.9 C13.5,7.8 12.8,7.3 12.5,6.7 L11,3.2 L9.5,6.6 C9.2,7.2 8.5,7.8 7.8,7.8 L3.9,8.2 L6.9,11.3 C7.4,11.8 7.6,12.6 7.4,13.3 L6.4,16.8 L9.9,14.4 C10.2,14.3 10.6,14.2 11,14.2 Z M17,20 C16.8,20 16.5,19.9 16.2,19.7 L11,16.2 L5.8,19.8 C5.1,20.3 4.5,20 4.3,19.9 C4.1,19.8 3.6,19.4 3.9,18.5 L5.5,12.9 C5.5,12.9 5.5,12.8 5.5,12.8 L1.4,8.6 C1,8.2 0.9,7.7 1.1,7.2 C1.3,6.7 1.7,6.4 2.3,6.4 L7.7,5.9 C7.7,5.9 7.8,5.9 7.8,5.8 L10,0.8 C10.1,0.3 10.5,0 11,0 C11.5,0 11.9,0.3 12.2,0.8 L14.4,5.8 C14.4,5.8 14.5,5.8 14.5,5.9 L19.9,6.4 C20.5,6.5 20.9,6.8 21.1,7.2 C21.3,7.7 21.1,8.2 20.7,8.6 L16.6,12.7 C16.6,12.7 16.6,12.8 16.6,12.8 L18.2,18.4 C18.4,19.3 17.9,19.7 17.8,19.8 C17.6,19.9 17.3,20 17,20 Z"
        />
      </g>
    </Icon>
  );
};

MultiColoredStarIcon.propTypes = {
  fill: PropTypes.string,
  border: PropTypes.string,
};

export default MultiColoredStarIcon;
